import { render, staticRenderFns } from "./TableBuyerCdpFirm.vue?vue&type=template&id=7ee74934&"
import script from "./TableBuyerCdpFirm.vue?vue&type=script&lang=ts&"
export * from "./TableBuyerCdpFirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports